import './PageCart.css';

export default function PageCart({
    content, onClick
}){
    return <div onClick={onClick} className='AppPageCart'>{content}</div>;
};